import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    mainContainer: {
      display: "flex",
      gap: "24px",
      flexWrap: "wrap",
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "center",
        gap: "18px",
        maxWidth: "343px",
      },
    },
    badgeSection: {
      display: "flex",
      gap: "6px",
    },
    assignedAgentCard: {
      padding: "20px 16px",
      width: "314px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    upperSection: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    leadId: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      color: theme.palette.text.secondary,
    },
    lowerSection: {
      display: "flex",
      alignItems: "flex-start",
      gap: "16px",
      marginTop: "12px",
    },
    avatarWrapper: {
      position: "relative",
      width: "60px",
      height: "60px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#FFF",
      boxShadow:
        "0px 4px 8px -2px rgba(16, 24, 40, 0.10), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)",
    },
    defaultAvatar: {
      background: theme.palette.background.secondary_hover,
      border: `1px solid ${theme.palette.border.avatarContrast}`,
      height: "56px",
      width: "56px",

      "& img": {
        height: "36px",
        width: "36px",
      },
    },
    agentName: {
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "28px",
      color: theme.palette.text.secondary,
    },
    skeletonContainer: {
      display: "flex",
      gap: "24px",
      flexWrap: "wrap",
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "center",
        gap: "18px",
        maxWidth: "343px",
      },
    },
  };
});
